
const environment = {
  TEST: {
    title: "One ügyfélelégedettségi rendszer",
    name: "test",
    apiRoot: window._env_.REACT_APP_API_URL,
    umamiUrl: window._env_.REACT_UMAMI_URL,
    umamiWebsiteDataId: window._env_.REACT_UMAMI_DATA_WEBSITE_ID,
  },
  PROD: {
    title: "One ügyfélelégedettségi rendszer",
    name: "production",
    apiRoot: window._env_.REACT_APP_API_URL,
    umamiUrl: window._env_.REACT_UMAMI_URL,
    umamiWebsiteDataId: window._env_.REACT_UMAMI_DATA_WEBSITE_ID,
  }
};

let envVar = {};
switch (window._env_.REACT_APP_STAGE) {
  case "TEST":
    envVar = environment.TEST;
    break;
  case "PROD":
    envVar = environment.PROD;
    break;
  default:
    envVar = environment.TEST;
}

export const env = envVar;
